import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TReadProjectsTimerParams = {
    users: boolean;
};

export default async ({ users }: TReadProjectsTimerParams) => {
    const headers = {
        auth: true,
    };

    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/project/readTimer?users=${users}`,
        method: "get",
        headers,
        // params: { length, page, hourProgressFilter, searchTerm, showArchived },
    });
    const { body, statusCode } = httpResponse;

    const errorFeedBacks = {};

    return handleStatusCases({
        body,
        statusCode,
        errorFeedBacks,
    });
};
